import React, {FC, useEffect, useState} from 'react'
import {Field, ErrorMessage, useField} from 'formik'
import {useIntl} from 'react-intl'

import CreatableSelect from 'react-select/creatable'
import {AnimaDireita2} from '../../../../../../../_metronic/assets/animation/styles'
import {colourStyles} from '../../../components/styles/styles'

const Step2: FC = () => {
  const intl = useIntl()
  const [field, ,] = useField('issue_date')
  const [field2, ,] = useField('expiration_date')
  const [field3, ,] = useField('limit_renovation')
  const [field4, ,] = useField('status')
  const [field5, ,] = useField('renovation_request_date')
  const [field6, ,] = useField('finalization_date')
  const [field7, ,] = useField('renovation_protocol')
  const [fieldRenewable, ,] = useField('renewable')

  const [fieldRenovationAlertDays, , helperRenovationAlertDays] = useField('renovation_alert_days')
  console.log('renovation_alert_days', fieldRenovationAlertDays)

  const [selectedRenovationAlertDays, setSelectedRenovationAlertDays] = useState<number[]>(
    fieldRenovationAlertDays.value
  )

  const handleInputChangeRenovationAlertDays = (event: any) => {
    console.log(event)
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(parseInt(event[i].value))
      }
    }
    setSelectedRenovationAlertDays(event)
    helperRenovationAlertDays.setValue(inputValue)
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>
            {intl.formatMessage({id: 'LICENSES.TITLE_STEAP2'})}
          </h2>
          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'LICENSES.SUBTITLE_STEAP2'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da segunda linha */}
          <div className='row'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.ISSUE_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input type='date' className='form-control form-control-solid  ps-6' {...field} />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'LICENSES.EXPIRATION_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input type='date' className='form-control form-control-solid  ps-6' {...field2} />
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          {fieldRenewable.value === true && (
            <div className='row mt-3'>
              <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bold required'>
                  {intl.formatMessage({id: 'LICENSES.LIMIT_DATE_RENEW'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='date'
                    className='form-control form-control-solid  ps-6'
                    {...field3}
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_RENEWAL_REQUEST_DATE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='date'
                    className='form-control form-control-solid  ps-6'
                    {...field5}
                  />
                </div>
              </div>
            </div>
          )}

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'COMMON.STATUS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...field4}
                  //onChange={(e) => setstatus(e.target.value)}
                >
                  <option></option>
                  <option value='valid'>{intl.formatMessage({id: 'LICENSES.STATUS_1'})}</option>
                  <option value='waiting_license'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_2'})}
                  </option>
                  <option value='in_renovation'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_3'})}
                  </option>
                  <option value='renewed_replaced'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_4'})}
                  </option>
                  <option value='finished'>{intl.formatMessage({id: 'LICENSES.STATUS_5'})}</option>
                  <option value='expired'>{intl.formatMessage({id: 'LICENSES.STATUS_6'})}</option>
                  <option value='changed_ownership'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_7'})}
                  </option>
                  <option value='waiting_documentation'>
                    {intl.formatMessage({id: 'LICENSES.STATUS_8'})}
                  </option>
                </select>
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'LICENSE_DATE_COMPLETION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input type='date' className='form-control form-control-solid  ps-6' {...field6} />
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da segunda linha */}
          {fieldRenewable.value === true && (
            <div className='row mt-3'>
              {selectedRenovationAlertDays && (
                <div className='col-lg-6'>
                  <label className='form-label fs-6 fw-bold'>
                    {intl.formatMessage({id: 'LICENSE_RENEWAL_NOTICE'})}
                  </label>
                  <div className='d-flex position-relative my-1'>
                    <CreatableSelect
                      className='form-control form-control-lg form-control-solid p-1 pl-1'
                      styles={colourStyles}
                      isMulti
                      placeholder='Quant. de dias'
                      {...fieldRenovationAlertDays}
                      value={selectedRenovationAlertDays}
                      onChange={handleInputChangeRenovationAlertDays}
                    />
                  </div>
                </div>
              )}

              <div className='col-lg-6'>
                <label className='form-label fs-6 fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_RENEWAL_PROTOCOL'})}
                </label>

                <div className='d-flex align-items-center position-relative my-1'>
                  <Field
                    name='renovation_protocol'
                    className='form-control form-control-lg form-control-solid'
                    // placeholder={intl.formatMessage({id: 'LICENSES.NUMBER_DOC'})}
                    placeholder=''
                  />
                  <div className='text-danger mt-2'>
                    <ErrorMessage name='renovation_protocol' />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* fim da segunda linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
